export default [
	{
		name: 'root',
		label: 'Countdown',
		selector: '&.countdown'
	},
	{
		name: 'item',
		label: 'Countdown Item',
		selector: '& .item'
	},
	{
		name: 'time_label',
		label: 'Time',
		selector: '& .item .time'
	},
	{
		name: 'label',
		label: 'Time Label',
		selector: '& .item .label'
	}
]